module.exports = __webpack_public_path__ + "img/thunderstorm.43cf4cbf.jpg";